var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('a',{staticClass:"pro-badge",attrs:{"href":_vm.trial ? _vm.learnmore_url : _vm.plansPage,"data-testid":_vm.testid,"target":"_blank"},on:{"click":_vm.sendEvent}},[_c('img',{attrs:{"width":"14","src":require("@img/icon-padlock.svg")}}),_c('span',{staticClass:"pro-badge-text"},[_vm._v("Pro")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }